var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconCompany(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 14.5V3.83333C12.6667 3.47971 12.5262 3.14057 12.2761 2.89052C12.0261 2.64048 11.687 2.5 11.3333 2.5H4.66667C4.31304 2.5 3.97391 2.64048 3.72386 2.89052C3.47381 3.14057 3.33333 3.47971 3.33333 3.83333V14.5M12.6667 14.5H14M12.6667 14.5H9.33333M3.33333 14.5H2M3.33333 14.5H6.66667M9.33333 14.5V11.1667C9.33333 10.9899 9.2631 10.8203 9.13807 10.6953C9.01305 10.5702 8.84348 10.5 8.66667 10.5H7.33333C7.15652 10.5 6.98695 10.5702 6.86193 10.6953C6.7369 10.8203 6.66667 10.9899 6.66667 11.1667V14.5M9.33333 14.5H6.66667M6 5.16667H6.66667M6 7.83333H6.66667M9.33333 5.16667H10M9.33333 7.83333H10",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconCompany);
export default __webpack_public_path__ + "static/media/common_icon_company.b13ff53dfc02d0d24f8edf61cb767358.svg";
export { ForwardRef as ReactComponent };